const events = {
  CANCEL: 'Clicked Cancel',
  KEEP_MEMBERSHIP: 'Clicked Keep Membership',
  CANCEL_REACTIVATION: 'Cancel Reactivation',
  CANCEL_REASON_CTA: 'Cancel Reason CTA',
  CANCELLED_SUBSCRIPTION_EXPERIMENT: 'Cancelled Subscription Experiment',
  CANCEL_REASON_SUBMITTED: 'Cancel Reason Submitted',
  REACTIVATION_COMPLETED: 'Reactivation Completed',
};

export default events;
